/* ==========================================================================
   SearcherBusHotel > Client > Select
   ========================================================================== */

/* Modules */
const SelectClient = require('@bluekiri/alexandria-contrib-components/components/select/client/js');
const config = require('./config');
const transactions = require('./transactions');

const groupLiterals = [];

const storedBusStations = {};

const removeDiacritics = str => str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

/* Init */
function initSelect(selector, instance) {
    const result = [];

    const choiceDataOrigins = instance.element.querySelector(
        `[data-component="Select"][data-type="${config().type.select}-0"]`
    ).dataset.items;
    const origins = choiceDataOrigins ? JSON.parse(choiceDataOrigins) : [];

    const choiceDataDestinations = instance.element.querySelector(
        `[data-component="Select"][data-type="${config().type.select}-1"]`
    ).dataset.items;
    const destinations = choiceDataDestinations ? JSON.parse(choiceDataDestinations) : [];

    instance.element.querySelectorAll('[data-component="Select"]').forEach((item, index) => {
        /* Push autocomplete */
        result.push(
            SelectClient(`${selector} [data-component="Select"][data-type="${config().type.select}-${index}"]`, {
                enableClick: true,
                choices: {
                    addItemText: '',
                    searchPlaceholderValue: instance.element.dataset.searcherbusstations,
                    noResultsText: instance.element.dataset.noresults,
                    noChoicesText: instance.element.dataset.nochoices,
                    searchEnabled: true,
                    searchChoices: false
                },
                onChange: [
                    function fn(e) {
                        if (e.element.getAttribute('data-type') === 'select-0') {
                            transactions.getBusStations(instance, storeCachedBusStations);
                            refreshBusStations(instance);
                        }
                        return false;
                    }
                ]
            })
        );
    });

    result[0].element.querySelector('input').addEventListener('input', function fn(event) {
        event.preventDefault();
        filterOriginBusStations(instance, this.value, origins);
    });

    result[1].element.querySelector('input').addEventListener('input', function fn(event) {
        event.preventDefault();
        filterBusStations(instance, this.value, destinations);
    });

    instance.element.addEventListener('loadBusStations', e => {
        refreshBusStations(e.detail.instance);
    });

    pushBusStationsLiterals(instance);

    return result;
}

function retrieveCachedBusStations(instance) {
    return storedBusStations[getOriginBusStation(instance.location)];
}

function pushBusStationsLiterals(instance) {
    groupLiterals.push(instance.element.dataset.selectorigin);
    groupLiterals.push(instance.element.dataset.selectdestination);
    groupLiterals.push(instance.element.dataset.busstations);
}

function storeCachedBusStations(rs, instance) {
    storedBusStations[getOriginBusStation(instance.location)] = rs;
    const event = CustomEvent('loadBusStations', {
        detail: {
            instance
        }
    });
    instance.element.dispatchEvent(event);
}

function getOriginBusStation(locations) {
    return `${locations[0].value}`;
}

function refreshBusStations(instance) {
    const busStations = retrieveCachedBusStations(instance);

    const destinations = GetDestinations(busStations, instance.searcherType);

    const headings = [groupLiterals[1], groupLiterals[2]];

    const newDestinationBusStations = [
        buildSelectBusStation(headings[0]),
        buildOptionWithChoices(1, headings[1], destinations)
    ];

    instance.location[1].setChoices(newDestinationBusStations, 'code', 'label', true);
}

function filterOriginBusStations(instance, value, choices) {
    const origins = choices[1].choices;
    const filterStations = FilterDestinations(origins, value);
    const headings = [groupLiterals[0], groupLiterals[2]];

    const newStations = [buildSelectBusStation(headings[0]), buildOptionWithChoices(1, headings[1], filterStations)];
    instance.location[0].setChoices(newStations, 'code', 'label', true);
}

function filterBusStations(instance, value, choices) {
    const busStations = retrieveCachedBusStations(instance);

    const destinations =
        busStations === undefined ? choices[1].choices : GetDestinations(busStations, instance.searcherType);
    const filterDestinations = FilterDestinations(destinations, value);
    const headings = [groupLiterals[1], groupLiterals[2]];

    const newDestinationBusStations = [
        buildSelectBusStation(headings[0]),
        buildOptionWithChoices(1, headings[1], filterDestinations)
    ];
    instance.location[1].setChoices(newDestinationBusStations, 'code', 'label', true);
}
function FilterDestinations(destinations, value) {
    return destinations.filter(destination =>
        removeDiacritics(destination.label).includes(removeDiacritics(value).toUpperCase())
    );
}

function GetDestinations(busStations, searcherType) {
    const destinations = [];

    if (searcherType === 'Playas' || searcherType === 'PlayasModel') {
        if (busStations !== undefined && busStations.destinations !== null) {
            for (let i = 0; i < busStations.destinations.length; i++) {
                const busStation = busStations.destinations[i];
                const destination = buildDestination(busStation);
                if (busStation.isCoast) destinations.push(destination);
            }
        }
    } else if (busStations !== undefined && busStations.destinations !== null) {
        for (let i = 0; i < busStations.destinations.length; i++) {
            const busStation = busStations.destinations[i];
            const destination = buildDestination(busStation);
            destinations.push(destination);
        }
    }

    return destinations;
}

function buildSelectBusStation(label) {
    return {
        label,
        value: 0,
        code: 0,
        selected: true
    };
}
function buildDestination(busStation) {
    return {
        isCoast: busStation.isCoast,
        label: busStation.label,
        code: `${busStation.code},${busStation.codeAirport}`
    };
}

function buildOptionWithChoices(code, label, choices) {
    return {
        label,
        id: code,
        disabled: false,
        choices
    };
}

module.exports = {
    initSelect
};
